import { Button } from "reactstrap";

const WhiteNavigator3 = ({ items, flowAt, setFlowAt,className }) => {
  return (
    <div className={`bg-white white-navigator-3 flex-md-nowrap flex-wrap  d-flex justify-content-md-evenly justify-content-strech align-items-center ${className}`}>
      {items?.map((item, index) => (
        <Button
          className={` ${flowAt === index ? "active" : ""}`}
          style={{ "--color": item?.color,paddingTop:'12px',paddingBottom:'12px' }}
          onClick={() => setFlowAt(index)}
        >
          {item?.title}
        </Button>
      ))}
    </div>
  );
};

export default WhiteNavigator3;
